import { render, staticRenderFns } from "./NewAttempt.vue?vue&type=template&id=1ef314c5&scoped=true"
import script from "./NewAttempt.vue?vue&type=script&lang=ts"
export * from "./NewAttempt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef314c5",
  null
  
)

export default component.exports